export const isLinearRampToValueAutomationEvent = (automationEvent) => {
    return automationEvent.type === 'linearRampToValue';
};
//# sourceMappingURL=linear-ramp-to-value-automation-event.js.map